import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRightIcon, CheckIcon, BellRingIcon, CircleIcon, MailIcon, ReplyIcon, ForwardIcon, MoreHorizontalIcon } from 'lucide-react';
export const BrandedEmailInterface = () => {
  return <div className="w-full h-full flex flex-col relative bg-gray-100 rounded-[24px] shadow-lg overflow-hidden" data-id="element-41">
      {/* Email client interface */}
      <div className="flex-grow p-1 sm:p-2 bg-gray-100 overflow-hidden" data-id="element-42">
        <div className="bg-white border border-gray-200 rounded-md shadow-sm h-full flex flex-col overflow-hidden" data-id="element-43">
          {/* Compact email header with sender info and action buttons */}
          <div className="flex justify-between items-center px-2 sm:px-4 py-1.5 border-b border-gray-200 flex-shrink-0" data-id="element-44">
            <div className="flex-1 min-w-0" data-id="element-45">
              <h1 className="text-xs sm:text-sm font-semibold text-gray-900 truncate pr-2" data-id="element-46">
                <span className="block sm:hidden" data-id="element-47">
                  Reminder: Submit Documents
                </span>
                <span className="hidden sm:block" data-id="element-48">
                  Reminder: Binding Documents for ACME
                </span>
              </h1>
              <div className="flex items-center flex-wrap" data-id="element-49">
                <div className="w-4 h-4 rounded-full bg-blue-100 flex items-center justify-center mr-1.5 flex-shrink-0" data-id="element-50">
                  <span className="text-[8px] font-bold text-blue-600" data-id="element-51">A</span>
                </div>
                <span className="text-[10px] text-gray-600 truncate" data-id="element-52">
                  ACME Corp. &lt;jsmith@acme.com&gt;
                </span>
                <span className="text-[10px] text-gray-400 ml-1 sm:ml-2 flex-shrink-0" data-id="element-53">
                  to me
                </span>
              </div>
            </div>
            <div className="flex space-x-1 ml-2 flex-shrink-0" data-id="element-54">
              <button className="p-1 text-gray-500 hover:bg-gray-100 rounded-full" data-id="element-55">
                <ReplyIcon className="h-3.5 w-3.5" data-id="element-56" />
              </button>
              <button className="hidden sm:flex p-1 text-gray-500 hover:bg-gray-100 rounded-full" data-id="element-57">
                <ForwardIcon className="h-3.5 w-3.5" data-id="element-58" />
              </button>
              <button className="p-1 text-gray-500 hover:bg-gray-100 rounded-full" data-id="element-59">
                <MoreHorizontalIcon className="h-3.5 w-3.5" data-id="element-60" />
              </button>
            </div>
          </div>
          {/* Email body - centered content with proper spacing */}
          <div className="p-2 flex-grow overflow-auto" data-id="element-61">
            <div className="flex flex-col items-center w-full max-w-[95%] xs:max-w-[90%] sm:max-w-[80%] mx-auto" data-id="element-62">
              {/* Top section with logo on left and progress pill on right */}
              <div className="flex justify-between items-start mb-2 w-full" data-id="element-63">
                {/* Company logo - left aligned */}
                <div data-id="element-64">
                  <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/ebckT2iyvbVwKRT7DWhE49/Highpoint_Logo_1920x1080_%281%29.png" alt="Highpoint Logo" className="h-4 sm:h-5 w-auto" data-id="element-65" />
                </div>
                {/* Progress pill on the right */}
                <div className="flex flex-col items-center" data-id="element-66">
                  <div className="w-12 sm:w-16 h-2 sm:h-3 bg-gray-200 rounded-full overflow-hidden" data-id="element-67">
                    <div className="h-full bg-green-500 rounded-full flex items-center justify-center text-[7px] sm:text-[8px] font-medium text-white" style={{
                    width: '75%'
                  }} data-id="element-68">
                      75%
                    </div>
                  </div>
                  <p className="text-[6px] sm:text-[7px] text-gray-500 mt-0.5" data-id="element-69">
                    3/4 completed
                  </p>
                </div>
              </div>
              {/* Blue notification box with bell icon */}
              <div className="bg-[#2E6BFF] p-1.5 sm:p-2 rounded-md text-white mb-2 w-full flex flex-col items-center" data-id="element-70">
                <BellRingIcon className="h-4 w-4 sm:h-5 sm:w-5 mb-0.5" data-id="element-71" />
                <div className="text-center" data-id="element-72">
                  <p className="font-medium text-xs sm:text-sm" data-id="element-73">
                    Reminder to submit binding documents to ACME
                  </p>
                  <p className="text-[10px] sm:text-xs mt-0.5 opacity-90" data-id="element-74">
                    POL112312333
                  </p>
                </div>
              </div>
              {/* Centered intro */}
              <div className="mb-2 text-center w-full" data-id="element-75">
                <p className="text-[10px] sm:text-xs text-gray-700" data-id="element-76">
                  Hi John, you have one outstanding checklist item to complete:
                </p>
              </div>
              {/* Checklist with dividers - widened and centered */}
              <div className="mb-3 w-full" data-id="element-77">
                <div className="w-full border border-gray-200 rounded-md" data-id="element-78">
                  {/* Item 1 - Completed */}
                  <div className="py-1 px-2 flex items-center border-b border-gray-200" data-id="element-79">
                    <div className="flex-shrink-0 mr-2 w-3.5 sm:w-4 h-3.5 sm:h-4 rounded-full bg-green-100 flex items-center justify-center text-xs font-medium text-green-600" data-id="element-80">
                      <CheckIcon className="h-2.5 sm:h-3 w-2.5 sm:w-3" data-id="element-81" />
                    </div>
                    <div data-id="element-82">
                      <h5 className="font-medium text-[10px] sm:text-xs text-gray-900" data-id="element-83">
                        ACORD Applications
                      </h5>
                    </div>
                  </div>
                  {/* Item 2 - Completed */}
                  <div className="py-1 px-2 flex items-center border-b border-gray-200" data-id="element-84">
                    <div className="flex-shrink-0 mr-2 w-3.5 sm:w-4 h-3.5 sm:h-4 rounded-full bg-green-100 flex items-center justify-center text-xs font-medium text-green-600" data-id="element-85">
                      <CheckIcon className="h-2.5 sm:h-3 w-2.5 sm:w-3" data-id="element-86" />
                    </div>
                    <div data-id="element-87">
                      <h5 className="font-medium text-[10px] sm:text-xs text-gray-900" data-id="element-88">
                        TRIA Form
                      </h5>
                    </div>
                  </div>
                  {/* Item 3 - Pending (highlighted in yellow) */}
                  <div className="py-1 px-2 flex items-center border-b border-gray-200 bg-yellow-100" data-id="element-89">
                    <div className="flex-shrink-0 mr-2 w-3.5 sm:w-4 h-3.5 sm:h-4 flex items-center justify-center" data-id="element-90">
                      <CircleIcon className="h-2.5 sm:h-3 w-2.5 sm:w-3 text-black" data-id="element-91" />
                    </div>
                    <div data-id="element-92">
                      <h5 className="font-medium text-[10px] sm:text-xs text-gray-900" data-id="element-93">
                        Underlying GL Policy
                      </h5>
                    </div>
                  </div>
                  {/* Item 4 - Completed */}
                  <div className="py-1 px-2 flex items-center" data-id="element-94">
                    <div className="flex-shrink-0 mr-2 w-3.5 sm:w-4 h-3.5 sm:h-4 rounded-full bg-green-100 flex items-center justify-center text-xs font-medium text-green-600" data-id="element-95">
                      <CheckIcon className="h-2.5 sm:h-3 w-2.5 sm:w-3" data-id="element-96" />
                    </div>
                    <div data-id="element-97">
                      <h5 className="font-medium text-[10px] sm:text-xs text-gray-900" data-id="element-98">
                        Supplemental Application(s)
                      </h5>
                    </div>
                  </div>
                </div>
              </div>
              {/* Action button - VIEW REQUEST - at the bottom */}
              <div className="flex justify-center" data-id="element-99">
                <a href="#" className="inline-flex items-center justify-center px-3 py-1.5 border border-transparent text-[10px] sm:text-xs font-medium rounded-md text-white bg-[#2E6BFF] hover:bg-[#1D5AFF] shadow-sm transition-colors duration-200 touch-action-manipulation" data-id="element-100">
                  VIEW REQUEST
                  <ArrowRightIcon className="ml-1 sm:ml-1.5 h-3 sm:h-3.5 w-3 sm:w-3.5" data-id="element-101" />
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>;
};